import { render, staticRenderFns } from "./VeJwBukaoList.vue?vue&type=template&id=7347fcf2"
import script from "./VeJwBukaoList.vue?vue&type=script&lang=js"
export * from "./VeJwBukaoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports